// src/actions/bankDetailActions.js

import axios from 'axios';
import { baseURL } from './types';
import {
  // UPI
  SUBMIT_UPI_DETAILS_REQUEST, SUBMIT_UPI_DETAILS_SUCCESS, SUBMIT_UPI_DETAILS_FAIL,
  UPDATE_UPI_DETAILS_REQUEST, UPDATE_UPI_DETAILS_SUCCESS, UPDATE_UPI_DETAILS_FAIL,
  DELETE_UPI_DETAILS_REQUEST, DELETE_UPI_DETAILS_SUCCESS, DELETE_UPI_DETAILS_FAIL,
  GET_UPI_DETAILS_REQUEST, GET_UPI_DETAILS_SUCCESS, GET_UPI_DETAILS_FAIL, // <-- ADDED

  // Bank
  SUBMIT_BANK_DETAILS_REQUEST, SUBMIT_BANK_DETAILS_SUCCESS, SUBMIT_BANK_DETAILS_FAIL,
  UPDATE_BANK_DETAILS_REQUEST, UPDATE_BANK_DETAILS_SUCCESS, UPDATE_BANK_DETAILS_FAIL,
  DELETE_BANK_DETAILS_REQUEST, DELETE_BANK_DETAILS_SUCCESS, DELETE_BANK_DETAILS_FAIL,
  GET_BANK_DETAILS_REQUEST, GET_BANK_DETAILS_SUCCESS, GET_BANK_DETAILS_FAIL, // <-- ADDED

  // Card
  SUBMIT_CARD_DETAILS_REQUEST, SUBMIT_CARD_DETAILS_SUCCESS, SUBMIT_CARD_DETAILS_FAIL,
  UPDATE_CARD_DETAILS_REQUEST, UPDATE_CARD_DETAILS_SUCCESS, UPDATE_CARD_DETAILS_FAIL,
  DELETE_CARD_DETAILS_REQUEST, DELETE_CARD_DETAILS_SUCCESS, DELETE_CARD_DETAILS_FAIL,
  
} from './types';

const getToken = () => localStorage.getItem('token');

// ==================
// --- UPI Actions ---
// ==================

// --- (NEW) GET UPI DETAILS ---
export const getUpiDetails = (hospitalID) => async (dispatch) => {
  dispatch({ type: GET_UPI_DETAILS_REQUEST });
  const config = {
    method: 'post',
    url: `${baseURL}/api/appointemntpaymentupidetails/getall`,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    data: { hospitalID }, // Pass hospitalID to get specific details
  };
  try {
    const response = await axios(config);
    dispatch({ type: GET_UPI_DETAILS_SUCCESS, payload: response.data.data }); // Dispatch inner data array
  } catch (error) {
    dispatch({ type: GET_UPI_DETAILS_FAIL, payload: error.message });
  }
};

export const submitUpiDetails = (upiData) => async (dispatch) => {
  dispatch({ type: SUBMIT_UPI_DETAILS_REQUEST });
  const config = {
    method: 'post',
    url: `${baseURL}/api/appointemntpaymentupidetails/create`,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    data: upiData,
  };
  try {
    const response = await axios(config);
    dispatch({ type: SUBMIT_UPI_DETAILS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: SUBMIT_UPI_DETAILS_FAIL, payload: error.message });
  }
};

export const updateUpiDetails = (upiData) => async (dispatch) => {
  dispatch({ type: UPDATE_UPI_DETAILS_REQUEST });
  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointemntpaymentupidetails/update`,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    data: upiData,
  };
  try {
    const response = await axios(config);
    dispatch({ type: UPDATE_UPI_DETAILS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: UPDATE_UPI_DETAILS_FAIL, payload: error.message });
  }
};

export const deleteUpi = (id, hospitalID) => async (dispatch) => {
  dispatch({ type: DELETE_UPI_DETAILS_REQUEST });
  try {
    await axios.delete(`${baseURL}/api/appointemntpaymentupidetails/delete`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
      data: { id, hospitalID },
    });
    dispatch({ type: DELETE_UPI_DETAILS_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_UPI_DETAILS_FAIL, payload: error.message });
  }
};


// ===================
// --- Bank Actions ---
// ===================

// --- (NEW) GET BANK DETAILS ---
export const getBankDetails = (hospitalID) => async (dispatch) => {
  dispatch({ type: GET_BANK_DETAILS_REQUEST });
  const config = {
    method: 'post',
    // Assuming the bank endpoint follows the same pattern
    url: `${baseURL}/api/appointemntpaymentbankdetails/getall`,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    data: { hospitalID },
  };
  try {
    const response = await axios(config);
    dispatch({ type: GET_BANK_DETAILS_SUCCESS, payload: response.data.data }); // Dispatch inner data array
  } catch (error) {
    dispatch({ type: GET_BANK_DETAILS_FAIL, payload: error.message });
  }
};

export const submitBankDetails = (bankData) => async (dispatch) => {
    dispatch({ type: SUBMIT_BANK_DETAILS_REQUEST });
    const config = {
        method: 'post',
        url: `${baseURL}/api/appointemntpaymentbankdetails/create`,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        data: bankData,
    };
    try {
        const response = await axios(config);
        dispatch({ type: SUBMIT_BANK_DETAILS_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: SUBMIT_BANK_DETAILS_FAIL, payload: error.message });
    }
};

export const updateBankDetails = (bankData) => async (dispatch) => {
    dispatch({ type: UPDATE_BANK_DETAILS_REQUEST });
    const config = {
        method: 'patch',
        url: `${baseURL}/api/appointemntpaymentbankdetails/update`,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        data: bankData,
    };
    try {
        const response = await axios(config);
        dispatch({ type: UPDATE_BANK_DETAILS_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: UPDATE_BANK_DETAILS_FAIL, payload: error.message });
    }
};

export const deleteBank = (id, hospitalID) => async (dispatch) => {
    dispatch({ type: DELETE_BANK_DETAILS_REQUEST });
    try {
        await axios.delete(`${baseURL}/api/appointemntpaymentbankdetails/delete`, {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
            data: { id, hospitalID },
        });
        dispatch({ type: DELETE_BANK_DETAILS_SUCCESS, payload: id });
    } catch (error) {
        dispatch({ type: DELETE_BANK_DETAILS_FAIL, payload: error.message });
    }
};